import {UnchangedSectionType} from 'config-migration/types/UnchangedSectionType';
import {ConfigMigrationAnalyticsAction} from 'constants/AnalyticsConstants';

import {
  BaseConfigMigrationEventMetadata,
  CompletedTimedConfigMigrationEventMetadata,
  trackConfigMigrationEvent,
} from './CommonConfigMigrationAnalytics';

// Metadata
export type ClickedUnchangedOrUnopenedItemsEventMetadata = BaseConfigMigrationEventMetadata & {
  header_type: UnchangedSectionType;
  num_items: number;
};

export interface CompletedMigrationImportObjectMetadata {
  total_migrated_object_count: number;
  migrated_object_count_by_type: Record<string, number>;
}

// Functions
export function trackOpenedUnchangedItems(metadata: ClickedUnchangedOrUnopenedItemsEventMetadata): void {
  trackConfigMigrationEvent(ConfigMigrationAnalyticsAction.OPENED_UNCHANGED_ITEMS, metadata);
}

export function trackInitiatedImportOrganizationConfigFile(metadata: BaseConfigMigrationEventMetadata): void {
  trackConfigMigrationEvent(
    ConfigMigrationAnalyticsAction.INITIATED_IMPORT_ORGANIZATION_CONFIG_FILE,
    metadata
  );
}

export function trackCompletedImportOrganizationConfigFile(
  metadata: CompletedTimedConfigMigrationEventMetadata
): void {
  trackConfigMigrationEvent(
    ConfigMigrationAnalyticsAction.COMPLETED_IMPORT_ORGANIZATION_CONFIG_FILE,
    metadata
  );
}

export function trackInitiatedImportConfiguration(metadata: BaseConfigMigrationEventMetadata): void {
  trackConfigMigrationEvent(ConfigMigrationAnalyticsAction.INITIATED_IMPORT_CONFIGURATION, metadata);
}

export function trackCompletedImportConfiguration(
  metadata: CompletedTimedConfigMigrationEventMetadata & CompletedMigrationImportObjectMetadata
): void {
  trackConfigMigrationEvent(ConfigMigrationAnalyticsAction.COMPLETED_IMPORT_CONFIGURATION, metadata);
}
